import { IconFont, SvgIcon } from '@/components'
import { Button, Card, Image, Progress, Tooltip, Typography } from 'antd'
import { useEffect, useState, useCallback, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { FixedSizeList } from 'react-window'
import { Particulars } from './particulars'
import { t } from '@/i18n'
const { Paragraph } = Typography
export const TaskMsg = props => {
  const { getTaskBasic, getTaskLogList, taskBasicsInfo } = props
  const [visible, setVisible] = useState({ visible: false, data: null })
  const closeVisible = () => {
    setVisible({ visible: false, data: null })
  }
  const [logShow, setLogShow] = useState<any>({ visible: false, item: [] })
  const [listHeight, setListHeight] = useState(140)
  const listContainerRef = useRef<HTMLDivElement>(null)

  // 计算列表高度
  useEffect(() => {
    const updateListHeight = () => {
      if (listContainerRef.current) {
        const container = listContainerRef.current
        const containerHeight = container.clientHeight
        // .task-list 高度是 164px，.progress 有 padding: 12px 10px，所以实际可用高度是 164 - 24 = 140px
        const calculatedHeight = containerHeight - 24
        if (calculatedHeight > 0) {
          setListHeight(calculatedHeight)
        } else {
          setListHeight(140) // 默认高度
        }
      }
    }
    // 延迟执行以确保 DOM 已渲染
    const timer = setTimeout(updateListHeight, 100)
    window.addEventListener('resize', updateListHeight)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('resize', updateListHeight)
    }
  }, [getTaskLogList?.items])

  // 虚拟列表项渲染函数
  const renderVirtualListItem = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const item = getTaskLogList?.items?.[index]
      if (!item) return null

      return (
        <div style={style}>
          <div
            className="progress-list"
            onClick={() => {
              setLogShow({ visible: true, item })
            }}
          >
            <div className="progress-list-left">
              {item?.status === '发送成功' && <div className="send-succeed">{t('发送成功')}</div>}
              {item?.status === '发送失败' && <div className="send-error">{t('发送失败')}</div>}
              <p>{item?.email}</p>
            </div>
            <div>{moment(item?.time).format('YYYY-MM-DD HH:mm:ss')}</div>
          </div>
        </div>
      )
    },
    [getTaskLogList?.items, setLogShow, t],
  )
  return (
    <div className="task-message">
      <TaskMessage
        style={{ width: '50%', marginRight: '16px' }}
        title={
          <div
            style={{
              paddingBottom: '16px',
              borderBottom: '1px solid #EAEDF1',
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '16px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SvgIcon width={16} height={16} name={'data-arrival'} fill={'#fff'} />
              <div style={{ marginLeft: 5 }}>{t('任务信息')}</div>
            </div>
            <div style={{ fontSize: 13, fontWeight: 400 }}>
              {t('执行类型：')}
              {getTaskBasic?.data?.status === 1 && <span> {t('预定')} </span>}
              {getTaskBasic?.data?.status === 2 && <span> {t('进行中')} </span>}
              {getTaskBasic?.data?.create_time}
            </div>
          </div>
        }
      >
        <div>
          <div className="task-type">
            <div>
              <span>{t('任务类型：')}</span>
              <span
                className={getTaskBasic?.data?.email_type === '钓鱼链接' ? 'phishing' : 'accessory'}
              >
                {getTaskBasic?.data?.email_type}
              </span>
            </div>
            <div
              style={{ cursor: 'pointer', color: '#4238C9' }}
              onClick={() => {
                setVisible({ visible: true, data: getTaskBasic?.data })
              }}
            >
              {t('查看详情')}
            </div>
          </div>
          <div className="task-type">
            <div style={{ display: 'flex' }}>
              <span>{t('评估目标：')}</span>
              <Typography.Text ellipsis={{ tooltip: true }} style={{ width: '300px' }}>
                {getTaskBasic?.data?.group_str}
              </Typography.Text>
            </div>
          </div>
          <div className="task-template">
            <div className="template">
              <div className="template-image">
                {getTaskBasic?.data?.email_from === 1 && (
                  <Image
                    width={64}
                    src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${
                      getTaskBasic?.data?.email_cover
                    }`}
                    preview={false}
                  />
                )}
                {(getTaskBasic?.data?.email_from === 2 || getTaskBasic?.data?.email_from === 3) &&
                  getTaskBasic?.data?.email_type === '钓鱼链接' && (
                    <SvgIcon
                      name={'phishing-link'}
                      width={'64'}
                      height={'64'}
                      style={{ marginTop: 20 }}
                    />
                  )}
                {(getTaskBasic?.data?.email_from === 2 || getTaskBasic?.data?.email_from === 3) &&
                  getTaskBasic?.data?.email_type === '恶意附件' && (
                    <SvgIcon
                      name={'phishing-task-accessory'}
                      width={'64'}
                      height={'64'}
                      style={{ marginTop: 20 }}
                    />
                  )}
              </div>
              <div className="content">
                <div className="title">{getTaskBasic?.data?.email_name}</div>
                <div className="text">
                  <div style={{ width: 80 }}>{t('邮件主题：')}</div>
                  <Typography.Text
                    ellipsis={{ tooltip: true }}
                    style={{ width: 'calc(100% - 80px)' }}
                  >
                    {getTaskBasic?.data?.email_subject}
                  </Typography.Text>
                </div>
                <div className="text">
                  <span>{t('发件人：')}</span>
                  <Tooltip placement="top" title={getTaskBasic?.data?.email_sender}>
                    <span className="name">{getTaskBasic?.data?.email_sender}</span>
                  </Tooltip>
                </div>
                <div className="text">
                  <span>{t('邮件类型：')}</span>
                  <span
                    className={
                      getTaskBasic?.data?.email_type === '钓鱼链接' ? 'phishing' : 'accessory'
                    }
                  >
                    {getTaskBasic?.data?.email_type}
                  </span>
                </div>
              </div>
            </div>
            <IconFont type={'icon-zengjia'} style={{ color: '#558492', padding: '0 4px' }} />
            <div className="template">
              {getTaskBasic?.data?.zip_pwd && (
                <div className="gzip">
                  <IconFont type="icon-suoping" /> <span>{t('压缩加密')}</span>
                </div>
              )}
              {getTaskBasic?.data?.is_compressed && !getTaskBasic?.data?.zip_pwd && (
                <div className="gzip">
                  <IconFont type="icon-suoping" /> <span>{t('压缩')}</span>
                </div>
              )}
              <div className="template-image">
                {getTaskBasic?.data?.page_from === 1 &&
                  getTaskBasic?.data?.email_type === '钓鱼链接' && (
                    <Image
                      width={64}
                      src={`${process.env.NODE_ENV === 'dev' ? '/api' : ''}${
                        getTaskBasic?.data?.page_cover
                      }`}
                      preview={false}
                    />
                  )}
                {(getTaskBasic?.data?.page_from === 2 || getTaskBasic?.data?.page_from === 3) &&
                  getTaskBasic?.data?.email_type === '钓鱼链接' &&
                  getTaskBasic?.data?.page_type === '钓鱼页+信息收集' && (
                    <SvgIcon name={'phishing-page-information'} width={'64'} height={'64'} />
                  )}
                {(getTaskBasic?.data?.page_from === 2 || getTaskBasic?.data?.page_from === 3) &&
                  getTaskBasic?.data?.email_type === '钓鱼链接' &&
                  getTaskBasic?.data?.page_type === '钓鱼页' && (
                    <SvgIcon name={'phishing-page'} width={'64'} height={'64'} />
                  )}
                {getTaskBasic?.data?.email_type === '恶意附件' && (
                  <>
                    {getTaskBasic?.data?.attach_type === 1 && (
                      <SvgIcon name={'exe'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                    {getTaskBasic?.data?.attach_type === 2 && (
                      <SvgIcon name={'doc-x'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                    {getTaskBasic?.data?.attach_type === 3 && (
                      <SvgIcon name={'xls-x'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                    {getTaskBasic?.data?.attach_type === 4 && (
                      <SvgIcon name={'ppt-x'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                    {getTaskBasic?.data?.attach_type === 5 && (
                      <SvgIcon name={'pdf'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                    {getTaskBasic?.data?.attach_type === 6 && (
                      <SvgIcon name={'rtf'} width={64} height={64} style={{ marginTop: 20 }} />
                    )}
                  </>
                )}
              </div>
              <div className="right">
                <div className="title">{getTaskBasic?.data?.page_name}</div>
                {getTaskBasic?.data?.email_type === '恶意附件' && (
                  <div className="text">
                    <span>{t('附件：')}</span>
                    <Typography.Text
                      ellipsis={{ tooltip: true }}
                      className="name"
                      style={{ width: 'calc(100% - 80px)' }}
                    >
                      {getTaskBasic?.data?.attach_file_name || '-'}
                    </Typography.Text>
                  </div>
                )}
                <div className="text">
                  <span>{t('重定向页面：')}</span>
                  <Tooltip placement="top" title={getTaskBasic?.data?.url}>
                    <u className="name" style={{ color: '#4238C9' }}>
                      {getTaskBasic?.data?.url || '-'}
                    </u>
                  </Tooltip>
                </div>
                {getTaskBasic?.data?.email_type === '钓鱼链接' && (
                  <div className="text">
                    <span>{t('钓鱼类型：')}</span>
                    <span className="gather">{getTaskBasic?.data?.page_type}</span>
                  </div>
                )}
                {getTaskBasic?.data?.email_type === '恶意附件' && (
                  <div className="text">
                    <span>{t('附件类型：')}</span>
                    {getTaskBasic?.data?.attach_type === 1 && (
                      <span className="accessory">EXE</span>
                    )}
                    {getTaskBasic?.data?.attach_type === 2 && (
                      <span className="accessory">DOC/X</span>
                    )}
                    {getTaskBasic?.data?.attach_type === 3 && (
                      <span className="accessory">XLS/X</span>
                    )}
                    {getTaskBasic?.data?.attach_type === 4 && (
                      <span className="accessory">PPT/X</span>
                    )}
                    {getTaskBasic?.data?.attach_type === 5 && (
                      <span className="accessory">PDF</span>
                    )}
                    {getTaskBasic?.data?.attach_type === 6 && (
                      <span className="accessory">RTF</span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </TaskMessage>
      <Particulars visible={visible} close={closeVisible} />
      {!logShow?.visible ? (
        <ScheduleMessage
          style={{ width: '50%' }}
          title={
            <div
              style={{
                paddingBottom: '16px',
                borderBottom: '1px solid #EAEDF1',
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '16px',
              }}
            >
              <div style={{ display: 'flex' }}>
                <SvgIcon width={16} height={16} name={'task-detail-schedule'} fill={'#fff'} />
                <div style={{ marginLeft: 5 }}>{t('进度信息')}</div>
                {getTaskBasic?.data?.status === 1 && <div className="reserve">{t('预定')}</div>}
                {getTaskBasic?.data?.status === 2 && <div className="underway">{t('进行中')}</div>}
                {getTaskBasic?.data?.status === 3 && <div className="accomplish">{t('完成')}</div>}
              </div>
              <div style={{ fontSize: 13, fontWeight: 400, display: 'flex' }}>
                <div>
                  {t('创建时间：')} {getTaskBasic?.data?.create_time}
                </div>
                <div style={{ marginLeft: 20 }}>
                  {t('任务时长：')}
                  {getTaskBasic?.data?.set_day}
                  {t('日')}
                </div>
              </div>
            </div>
          }
        >
          <Progress
            strokeColor={{
              '0%': '#fff',
              '100%': '#0346F2',
            }}
            success={{ percent: -1 }}
            percent={
              getTaskBasic?.data?.status === 1
                ? 0
                : getTaskBasic?.data?.status === 2
                ? Number(
                    Number(
                      getTaskBasic?.data?.rate +
                        ((getTaskLogList?.items?.length || 1) * 50) /
                          (taskBasicsInfo.create_num || 1),
                    ).toFixed(0),
                  )
                : getTaskBasic?.data?.status === 3
                ? 100
                : 0
            }
          />

          <div className="task-list" ref={listContainerRef}>
            <div className="progress">
              {getTaskLogList?.items && getTaskLogList.items.length > 0 ? (
                <FixedSizeList
                  height={listHeight}
                  itemCount={getTaskLogList.items.length}
                  itemSize={36}
                  width="100%"
                >
                  {renderVirtualListItem}
                </FixedSizeList>
              ) : null}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div>
              {t('执行开始时间：')}
              {getTaskBasic?.data?.start_time}
            </div>
            <div style={{ marginLeft: 10 }}>
              {t('结束时间：')}
              {getTaskBasic?.data?.end_time}
            </div>
          </div>
        </ScheduleMessage>
      ) : (
        <LogMessage
          title={
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                justifyItems: 'center',
                borderBottom: '1px solid rgb(234, 237, 241)',
                paddingBottom: '10px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  style={{
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginRight: '12px',
                    marginLeft: 5,
                    background: '#F1F3F8',
                    border: '0px',
                  }}
                  icon={<IconFont type="icon-fanhui2" style={{ fontSize: '12px' }} />}
                  onClick={() => {
                    setLogShow({ visible: false, item: [] })
                  }}
                />

                <div className="title-text">{t('日志:')}</div>
                <Typography.Text
                  className="title-main-text"
                  style={{ width: 300 }}
                  ellipsis={{
                    tooltip: {
                      getPopupContainer: (node: any) => document.body,
                    },
                  }}
                >
                  {logShow?.item?.email}
                </Typography.Text>
              </div>
              <div className="title-text">{logShow?.item?.time}</div>
            </div>
          }
        >
          <div className="task-list">
            {/* <Scrollbars> */}
            <div style={{ display: 'flex' }}>
              <Paragraph copyable={{ text: logShow?.item?.details }} style={{ margin: 0 }} />
              {/* <div>{logShow?.item?.details}</div> */}
              <div>
                {logShow?.item?.details?.map((item, index) => (
                  <div className="title-main-text" key={index}>
                    {item.indexOf('Reply:') === 0 && (
                      <>
                        <span style={{ color: '#C586C0' }}>Reply：</span>
                        <span>
                          {item.substring(
                            item.indexOf('Reply:') + 6,
                            item.indexOf('Msg') > -1 ? item.indexOf('Msg') : undefined,
                          )}
                        </span>
                      </>
                    )}
                    {item.indexOf('Msg:') > 0 && (
                      <>
                        <span style={{ color: '#559CD6' }}>Msg：</span>
                        <span>{item.substring(item.indexOf('Msg:') + 4)}</span>
                      </>
                    )}
                    {item.indexOf('Send:') === 0 && (
                      <>
                        <span style={{ color: '#55A721' }}>Send:</span>
                        <span>{item.substring(item.indexOf('Send:') + 4)}</span>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {/* </Scrollbars> */}
          </div>
        </LogMessage>
      )}
    </div>
  )
}
const TaskMessage = styled(Card)`
  border: none;
  background-color: #f8f9fb;
  .task-type {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .text {
    display: flex;
    align-items: center;
  }
  .name {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    overflow: hidden;
    width: 50%;
    line-height: 1.2;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }
  .accessory {
    padding: 4px 8px;
    background: #f5d9da;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #d0011c;
  }
  .task-template {
    width: 100%;
    background: #f8f9fb;
    min-height: 155px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 16px 10px;
    .template {
      max-width: calc(50% - 11px);
      min-width: calc(50% - 11px);
      background-color: #fff;
      height: 100%;
      border-radius: 8px;
      padding: 19px 16px;
      position: relative;
      display: flex;
      overflow: hidden;
      .gzip {
        position: absolute;
        color: #f53f3f;
        background: #feebeb;
        font-size: 12px;
        width: 200px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        left: -65px;
        top: 15px;
        transform: rotateZ(325deg);
      }
      .template-image {
        width: 64px;
        height: 85px;
        border-radius: 8px;
        overflow: hidden;
      }
      .content {
        width: 70%;
        height: 100px;
        margin-left: 10px;
        .title {
          font-weight: 600;
          margin-bottom: 8px;
        }
        .text {
          color: #666;
          margin-bottom: 8px;
        }
        .name {
          display: inline-block;
          width: 50%;
          overflow: hidden;
          line-height: 1.2;
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .right {
    width: 70%;
    margin-left: 10px;
    height: 100px;
    .content {
      margin-left: 10px;
    }
    .title {
      font-weight: 600;
      margin-bottom: 14px;
    }
    .text {
      color: #666;
      margin-bottom: 14px;
    }
  }
  .phishing {
    padding: 4px 8px;
    background: #ebe9ff;
    border-radius: 4px;
    color: #645aff;
    font-size: 12px;
  }
  .gather {
    padding: 4px 8px;
    background: #e0f2f2;
    border-radius: 4px;
    color: #65bdc0;
    font-size: 12px;
  }
`
const ScheduleMessage = styled(Card)`
  border: none;
  background-color: #f8f9fb;
  .reserve {
    font-size: 12px;
    padding: 3px 7px;
    color: #ffad31;
    background: #fff3e1;
    margin-left: 10px;
    border-radius: 9px;
    font-weight: initial;
  }
  .underway {
    font-size: 12px;
    padding: 3px 7px;
    color: #2973ff;
    background: #e9f1ff;
    margin-left: 10px;
    border-radius: 9px;
    font-weight: initial;
  }
  .accomplish {
    font-size: 12px;
    padding: 3px 7px;
    color: #67c23a;
    background: #f2f9eb;
    margin-left: 10px;
    border-radius: 9px;
    font-weight: initial;
  }
  .task-list {
    height: 164px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    margin-top: 16px;
    margin-bottom: 13px;
  }
  .progress {
    padding: 12px 10px;
    .progress-list {
      width: 100%;
      display: flex;
      cursor: pointer;
      align-items: center;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      margin-bottom: 4px;
      //background: #f7f7f7;
      background: #fff;
      border-radius: 6px;
      justify-content: space-between;
      transition: all 0.2s;
      &:hover {
        background: #e7e9f3;
      }
    }
    .progress-list-left {
      display: flex;
      align-items: center;
      p {
        margin: 0;
      }
    }
  }
  .send-error {
    padding: 4px 8px;
    border: 1px solid #f98388;
    color: #f5222d;
    background-color: #fee4e5;
    display: flex;
    align-items: center;
    border-radius: 6px;
    height: 24px;
    margin-right: 10px;
  }
  .send-succeed {
    padding: 4px 8px;
    border: 1px solid #abc6ff;
    color: #6f9fff;
    background-color: #e9f0ff;
    display: flex;
    align-items: center;
    border-radius: 6px;
    height: 24px;
    margin-right: 10px;
  }
`
const LogMessage = styled(Card)`
  border: none;
  background-color: #f8f9fb;
  width: 50%;
  .title-text {
    font-size: 14px;
    font-weight: 400;
    margin-left: 10px;
    height: 14px;
  }
  .task-list {
    height: 200px;
    margin-top: 16px;
    margin-bottom: 13px;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 10px;
    padding-right: 0;
    overflow-y: auto;
  }
  .title-main-text {
    font-size: 14px;
    word-break: break-all;
    word-wrap: break-word;
    font-weight: 400;
    margin-left: 10px;
    padding-right: 10px;
  }
`
